var React = require('react');

function Folder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFA000","d":"M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v8h40v-4C44,13.8,42.2,12,40,12z","key":0}),React.createElement("path",{"fill":"#FFCA28","d":"M40,12H8c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V16C44,13.8,42.2,12,40,12z","key":1})]);
}

Folder.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 48 48","version":"1","enableBackground":"new 0 0 48 48"};

module.exports = Folder;

Folder.default = Folder;
